import {Component} from "@angular/core";

@Component({
  selector: 'app-detail-table',
  templateUrl: './mandate-listings.component.html',
  styleUrls: ['../../../detail-screen/detail-screen.component.css'],
})

export class MandateListingsComponent {
  tableColumns: string[];
  tableData: any[];
  emptyValuePlaceholder = '-';
  showTable: boolean;

  constructor() {
    this.tableColumns = [];
    this.tableData = [];
    this.showTable = true;
  }

}
